import { createPayload } from './common'

export const createSetAction = (name, data) => createAction(`${name}_SET`, data)
export const createClearAction = (name) => createAction(`${name}_CLEAR`)

const createAction = (type, data) => ({
  type,
  payload: createPayload(data)
})



// WEBPACK FOOTER //
// ./src/store/utils/syncAction.js